import axios from 'axios';
import { sessionService } from 'redux-react-session';
import Notification from './../utils/notification';
import AuthService from './../services/authService';

export default function (store, _history) {
    let isRefreshing = false;
    let refreshSubscribers = [];

    const errorHandler = error => {
        const originalRequest = error.config;

        if (error.response && error.response.status) {

            if (error.response.status === 401) {
                let error_data = error.response.data;

                if (error_data.error_type === 'expired_access_token') {
                    if (!isRefreshing) {
                        isRefreshing = true;

                        return new Promise((resolve, reject) => {
                            AuthService.refreshToken().then((response) => {
                                let data = response.data;
                                sessionService.saveSession({ ...data })
                                originalRequest.headers['Authorization'] = 'Bearer ' + response.data.access_token;

                                isRefreshing = false;
                                onRefreshed(response.data.access_token);
                                refreshSubscribers = [];

                                return resolve(axios.request(originalRequest));
                            }).catch((error) => {
                                isRefreshing = false;
                                refreshSubscribers = [];

                                return reject(error);
                            })
                        })
                    } else {
                        return new Promise((resolve) => {
                            subscribeTokenRefresh(token => {
                                // replace the expired token and retry
                                originalRequest.headers['Authorization'] = 'Bearer ' + token;
                                resolve(axios.request(originalRequest));
                            })
                        })
                    }
                }
                sessionService.deleteSession()
                sessionService.deleteUser();
                store.dispatch({ type: 'HIDE_PAGE_LOADER' });
                return Promise.reject(error);
            } else {
                return Promise.reject(error);
            }
        } else {
            Notification.show('warning', { message: 'No Internet Connection, Try Again !' });
            store.dispatch({ type: 'HIDE_PAGE_LOADER' });
            return Promise.reject(error);
        }
    };

    const subscribeTokenRefresh = (cb) => {
        refreshSubscribers.push(cb);
    };

    const onRefreshed = (token) => {
        refreshSubscribers.map(cb => cb(token));
    };

    axios.interceptors.response.use(response => response, errorHandler);
}